module.exports = __webpack_public_path__ + "img/title.9e1a0e8f.webp";